import { getEnvRelatedBaseUrl } from './url';

export const defaultTosUrlKey = 'atp.url.terms_of_service';
export const defaultPrivacyPolicyUrlKey = 'atp.url.privacy_policy';

export const getDefaultTosUrl = () =>
    getEnvRelatedBaseUrl('/en/terms-of-service.pdf');
export const getDefaultPrivacyPolicyUrl = () =>
    getEnvRelatedBaseUrl('/en/privacy-security.pdf');

export const CookiesNames = {
    TOKEN: 'token',
    HAS_TOKEN: 'hasToken',
    USER_PREFERENCES_STEPS_COMPLETED: 'user-preferences-steps-completed',
    USER_PREFERENCES_SKIP: 'user-preferences-skip',
    USER_PREFERENCES_SKIP_COUNT: 'user-preferences-skip-count',
    EVENT_URL: 'event_url',
    LANG: 'lang-atp',
    START_CHAT_WITH: 'start-chat-with',
} as const;

export const gtmBaseUrl = 'https://www.googletagmanager.com';

export const TOKEN_MAX_AGE_IN_YEARS = 2;

export const defaultLocale = 'en';
export const defaultLocaleIcuCode = 'en_US';
